import { parseNumericValue } from 'lib/parse-numeric-value'
import React, { FC } from 'react'
import { Input, InputProps } from 'ui/input'

export interface Props extends Omit<InputProps, 'onChange' | 'value' | 'type' | 'formatter'> {
  value: number
  onChange: (value: number) => void
  formatter?: (value: number) => string
}

export const NumberInput: FC<Props> = ({ value, onChange, formatter, ...rest }) => {
  const numberFormatter = (value: string) => {
    const numericValue = parseNumericValue(value)
    return formatter ? formatter(numericValue) : numericValue.toString()
  }

  return (
    <Input
      onChange={(value) => onChange(parseNumericValue(value))}
      value={value.toString()}
      formatter={numberFormatter}
      {...rest}
    />
  )
}
